import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeEvery } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { InvitedMembers } from 'data/members/slice';
import { updateProjectMembers } from 'data/projects/actions';
import { add } from 'stores/memberships';

interface Callback {
  (data: any): void;
}

function* updateProjectMembersSaga(
  action: PayloadAction<{
    projectId: number;
    members: InvitedMembers[];
    handleSuccess?: Callback;
    handleFailure?: Callback;
  }>,
) {
  const { payload } = action;
  const { projectId, members, handleSuccess, handleFailure } = payload;

  try {
    const response = yield ProjectAPI.updateMembers(projectId, members);

    if (handleSuccess) {
      handleSuccess(payload);
    }
    yield put(
      add({
        projectId: ProjectId(projectId),
        memberships: response.map(
          ({
            user: { userId },
            permissionSet: { permissionSetType: memberType },
            joinedAt,
          }) => ({ userId: UserId(userId), memberType, joinedAt }),
        ),
      }),
    );
  } catch (error) {
    if (handleFailure) {
      handleFailure(error);
    }
  }
}

export const watchUpdateProjectMembersSaga = function* (): Generator {
  yield takeEvery(updateProjectMembers.type, updateProjectMembersSaga);
};
